import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
  
class SidebarPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            CUSTOMER_DET: props.CUSTOMER_DET
        };
    }

    render() { 

        let NAME = '';
        let EMAIL = '';
        let MOBILE = '';

        if(this.state.CUSTOMER_DET!='')
        {
            let customer = this.state.CUSTOMER_DET.split('~~**~~');
            NAME = customer[0];
            if(customer[1]!='' && customer[1]!=undefined)
                EMAIL = customer[1];
            if(customer[2]!='' && customer[2]!=undefined)
                MOBILE = customer[2];
        }

        return (
            <div className="modal fade panelbox panelbox-right" id="sidebarPanel" tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body p-0">
                            <div className="profileBox">
                                <div className="in pr-0">
                                    {NAME!='' && <strong>{NAME}</strong>}
                                    {EMAIL!= '' && <div className="text-muted">
                                        {EMAIL}
                                    </div>}
                                    {MOBILE!= '' && <div className="text-muted">
                                        {MOBILE}
                                    </div>}
                                </div>
                                <Link to="javascript:;" className="close-sidebar-button" data-dismiss="modal">
                                    <ion-icon name="close"></ion-icon>
                                </Link>
                            </div>
                            <ul className="listview flush transparent no-line image-listview mt-2">
                                <li>
                                    <Link to="/categories" className="item">
                                        <div className="in"> Categories </div>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/special-offers" className="item">
                                        <div className="in">
                                            <div>Special Offers</div>
                                        </div>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/about-us" className="item">
                                        <div className="in"> About Us </div>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/cancellation-and-refunds" className="item">
                                        <div className="in"> Cancellations & Refunds </div>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/privacy-policy" className="item">
                                        <div className="in"> Privacy Policy </div>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/terms-and-conditions" className="item">
                                        <div className="in"> Terms & Conditions </div>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/disclaimer" className="item">
                                        <div className="in"> Disclaimer </div>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
      
export default SidebarPanel;


// WEBPACK FOOTER //
// ./src/components/SidebarPanel.js